/**
 * @generated SignedSource<<8e0d329a3b35ef67a74326154f52a1d0>>
 * @relayHash dffa05df67ca6af1a033996fbe676439
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d8050e0e5175ff4968c7ffc09c01e49a0750193d4fd0091a523c9d2cb35dfc68

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type HelpCenterPageUpdateInput = {
  description?: string | null | undefined;
  helpCenterPageAri: string;
  name: string;
  pageLayout?: HelpCenterPageLayoutInput | null | undefined;
};
export type HelpCenterPageLayoutInput = {
  layoutAdf?: string | null | undefined;
  metadata?: string | null | undefined;
};
export type mainHubUpdateMutation$variables = {
  cloudId: string;
  input: HelpCenterPageUpdateInput;
};
export type mainHubUpdateMutation$data = {
  readonly helpCenter: {
    readonly updateHelpCenterPage: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly helpCenterPage: {
        readonly description: {
          readonly default: string | null | undefined;
        } | null | undefined;
        readonly helpCenterAri: string;
        readonly id: string;
        readonly name: {
          readonly default: string;
        } | null | undefined;
        readonly updatedAt: string | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type mainHubUpdateMutation = {
  response: mainHubUpdateMutation$data;
  variables: mainHubUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  {
    "kind": "ScalarField",
    "name": "default"
  }
],
v8 = {
  "concreteType": "HelpCenterPage",
  "kind": "LinkedField",
  "name": "helpCenterPage",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "concreteType": "HelpCenterPageName",
      "kind": "LinkedField",
      "name": "name",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "concreteType": "HelpCenterPageDescription",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": (v7/*: any*/)
    },
    {
      "kind": "ScalarField",
      "name": "helpCenterAri"
    },
    {
      "kind": "ScalarField",
      "name": "updatedAt"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "mainHubUpdateMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterMutationApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "HelpCenterPageUpdatePayload",
            "kind": "LinkedField",
            "name": "updateHelpCenterPage",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              },
              (v8/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "mainHubUpdateMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "HelpCenterMutationApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "HelpCenterPageUpdatePayload",
            "kind": "LinkedField",
            "name": "updateHelpCenterPage",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              },
              (v8/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d8050e0e5175ff4968c7ffc09c01e49a0750193d4fd0091a523c9d2cb35dfc68",
    "metadata": {},
    "name": "mainHubUpdateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ed99611a1ac21c19d5d2d76b18affda7";

export default node;
